// Module
var code = "<template>\n    <require from=\"pages/dashboard/widgets/favorites/index\" as=\"favorites\"></require>\n    <div class=\"row\">\n        <div class=\"col-3\">\n            <favorites />\n        </div>\n    </div>\n</template>";
// Exports
export default code;